import { type AllAppExtensionMounts } from "@dashboard/extensions/domain/app-extension-manifest-available-mounts";

export const extensionMountPoints = {
  CATEGORY_LIST: ["CATEGORY_OVERVIEW_CREATE", "CATEGORY_OVERVIEW_MORE_ACTIONS"],
  COLLECTION_LIST: ["COLLECTION_OVERVIEW_CREATE", "COLLECTION_OVERVIEW_MORE_ACTIONS"],
  GIFT_CARD_LIST: ["GIFT_CARD_OVERVIEW_CREATE", "GIFT_CARD_OVERVIEW_MORE_ACTIONS"],
  CUSTOMER_LIST: ["CUSTOMER_OVERVIEW_CREATE", "CUSTOMER_OVERVIEW_MORE_ACTIONS"],
  PRODUCT_LIST: ["PRODUCT_OVERVIEW_CREATE", "PRODUCT_OVERVIEW_MORE_ACTIONS"],
  ORDER_LIST: ["ORDER_OVERVIEW_CREATE", "ORDER_OVERVIEW_MORE_ACTIONS"],
  DRAFT_ORDER_LIST: ["DRAFT_ORDER_OVERVIEW_CREATE", "DRAFT_ORDER_OVERVIEW_MORE_ACTIONS"],
  DISCOUNT_LIST: ["DISCOUNT_OVERVIEW_CREATE", "DISCOUNT_OVERVIEW_MORE_ACTIONS"],
  VOUCHER_LIST: ["VOUCHER_OVERVIEW_CREATE", "VOUCHER_OVERVIEW_MORE_ACTIONS"],
  PAGE_LIST: ["PAGE_OVERVIEW_CREATE", "PAGE_OVERVIEW_MORE_ACTIONS"],
  PAGE_TYPE_LIST: ["PAGE_TYPE_OVERVIEW_CREATE", "PAGE_TYPE_OVERVIEW_MORE_ACTIONS"],
  MENU_LIST: ["MENU_OVERVIEW_CREATE", "MENU_OVERVIEW_MORE_ACTIONS"],
  COLLECTION_DETAILS: ["COLLECTION_DETAILS_MORE_ACTIONS", "COLLECTION_DETAILS_WIDGETS"],
  CATEGORY_DETAILS: ["CATEGORY_DETAILS_MORE_ACTIONS"],
  GIFT_CARD_DETAILS: ["GIFT_CARD_DETAILS_MORE_ACTIONS", "GIFT_CARD_DETAILS_WIDGETS"],
  CUSTOMER_DETAILS: ["CUSTOMER_DETAILS_MORE_ACTIONS", "CUSTOMER_DETAILS_WIDGETS"],
  ORDER_DETAILS: ["ORDER_DETAILS_MORE_ACTIONS", "ORDER_DETAILS_WIDGETS"],
  DRAFT_ORDER_DETAILS: ["DRAFT_ORDER_DETAILS_MORE_ACTIONS", "DRAFT_ORDER_DETAILS_WIDGETS"],
  PRODUCT_DETAILS: ["PRODUCT_DETAILS_MORE_ACTIONS", "PRODUCT_DETAILS_WIDGETS"],
  DISCOUNT_DETAILS: ["DISCOUNT_DETAILS_MORE_ACTIONS"],
  VOUCHER_DETAILS: ["VOUCHER_DETAILS_MORE_ACTIONS", "VOUCHER_DETAILS_WIDGETS"],
  PAGE_DETAILS: ["PAGE_DETAILS_MORE_ACTIONS"],
  PAGE_TYPE_DETAILS: ["PAGE_TYPE_DETAILS_MORE_ACTIONS"],
  MENU_DETAILS: ["MENU_DETAILS_MORE_ACTIONS"],
  NAVIGATION_SIDEBAR: [
    "NAVIGATION_CATALOG",
    "NAVIGATION_CUSTOMERS",
    "NAVIGATION_DISCOUNTS",
    "NAVIGATION_ORDERS",
    "NAVIGATION_PAGES",
    "NAVIGATION_TRANSLATIONS",
  ],
  TRANSLATION_DETAILS: ["TRANSLATIONS_MORE_ACTIONS"],
} as const satisfies Record<string, Array<AllAppExtensionMounts>>;
